<template>
  <card-seplag titulo="Fiscalização Declarações">
    <div class="p-col-12 container">
      <div class="container-cabecalho">
        <div>
          <span class="label-info">Órgão: </span>
          <span>{{ userOrgao }}</span>
        </div>

        <div>
          <span class="label-info">Fiscalizador: </span>
          <span>{{ userName }}</span>
        </div>
      </div>

      <div class="container-filtro">
        <Rotulo nome="Digite CPF, matrícula ou nome" cols="12 6">
          <InputText type="text" v-model="textoBusca" />
        </Rotulo>
        <Button
          icon="pi pi-search"
          @click="buscaServidor"
          label="buscar"
          class="classe-buttom"
        />
      </div>
    </div>

    <DataTable
      :value="dados.content"
      :expandedRows.sync="expandedRows"
      dataKey="idenPessoa"
      responsiveLayout="scroll"
      @row-expand="onRowExpand"
      class="p-col-12"
    >
      <Column :expander="true" :headerStyle="{ width: '3rem' }" />
      <Column field="nomePessoa" header="Nome" sortable></Column>
      <Column field="descOrgao" header="Órgão" sortable></Column>      
      <Column field="cpfFormatado" header="CPF" sortable></Column>
      
      <template #expansion="">
          <DataTable :value="dadosExercicioPessoa" v-if="dadosExercicioPessoa">            
            <Column field="ano" header="Exercício" sortable></Column>
            <Column field="tipoDeclaracaoDesc" header="Tipo Declaração" sortable></Column>
            <Column field="numrProtocolo" header="Protocolo" sortable></Column>           
            <Column :headerStyle="{ width: '8rem' }">
              <template #body='slotProps'>
                <Button
                 @click="exportPDF(slotProps.data)"
                  label="PDF"
                  icon="pi pi-external-link"
                  class="p-button-raised"
                  style="margin: 5px; background: #c5031d; border-color: #b70019"
                />
              </template>
            </Column>
          </DataTable>
          <div v-else>
            <h5> Não Possui Dados </h5>
          </div>
      </template>
    </DataTable>

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </card-seplag>
</template>

<script >
import CardSeplag from "@/template/CardSeplag.vue";
import { baseApiUrl } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import download from "downloadjs";
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "fiscalizacao",
  components: { CardSeplag, Rotulo, CardExibirPDF },

  data: function () {
    return {
      anoAtual: new Date().getFullYear(),
      userName: "",
      userOrgao: "",
      matriculaUsuario: null,
      idenPessoaUsuario: null,
      formTitulo: "",
      isVisibleForm: false,
      idenPessoaExercicio: null,
      resultadoBusca: null,
      camposTabelaPessoa: [
        { nome: "cpf", titulo: "CPF" },
        { nome: "nome", titulo: "Nome" },
      ],
      filtroTabelaFiscalizacao: {
        idenExercicio: null,
        textoPesquisa: null,
        tipoPesquisa: { codTipo: "N", descTipo: "Nome" },
      },
      dados: {
        content: [],
      },
      camposTabelaFiscalizacao: [
        { nome: "dataOperacaoFormatada", titulo: "Data/Hora" },
        { nome: "endrIpCliente", titulo: "IP" },
        { nome: "tabela", titulo: "Tela" },
        { nome: "acao", titulo: "Ação" },
        { nome: "informacaoDetalhe", titulo: "Informação/Detalhe" },
      ],
      dropdownTipoPesquisa: [
        { codTipo: "N", descTipo: "Nome" },
        { codTipo: "M", descTipo: "Matrícula" },
        { codTipo: "C", descTipo: "CPF" },
      ],
      nomesFiltrados: [],
      textoBusca: null,
      isExibirPDF: false,
      tituloPDF: " ",
      dadosRelatorioBase64: "",
      expandedRows: null,
      dadosExercicioPessoa: null
    };
  },

  methods: {

    onRowExpand(event) {      
      this.expandedRows = null
      this.$http.get(`${baseApiUrl}/permissoesfiscais/${this.idenPessoaUsuario}/${event.data.idenPessoa}`)
        .then((res) => {
          this.dadosExercicioPessoa = res.data;
          this.expandedRows = [Object.assign({},event.data)]
        });
    },
    carregarDados() {
      //console.log(this.$store);
      this.matriculaUsuario =  this.$store.getters.getUser.contaAcesso.pessoa.servidor ?  this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula : "";
      this.idenPessoaUsuario = this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa;
      this.userName = this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa;
      this.userOrgao = this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao;    
    },

    limparCampos() {
      this.idenPessoaExercicio = null;
      this.dados.content = [];
      this.textoBusca = "";
    },

    buscaServidor() {   
        this.$http.post(`${baseApiUrl}/permissoesfiscais/buscadinamica/${this.idenPessoaUsuario}`,this.textoBusca?this.textoBusca:'todos')
          .then((res) => {
            this.dados = res.data;
          });     
    },

    onSearchPaginacao(rows, page) {
      this.$http
        .get(
          `${baseApiUrl}/auditorias/pessoaexercicio/${this.idenPessoaExercicio}?size=${rows}&page=${page}`,
          JSON.stringify(this.idenPessoaExercicio)
        )
        .then((res) => {
          this.dados = res.data;
          this.totalRegistro = res.data.totalElements;
        });
    },

    onSearchPaginacaoPessoa(rows, page) {
      this.verificaVazio();
      this.$http
        .post(
          `${baseApiUrl}/pessoaexercicios/pesquisaud?size=${rows}&page=${page}`,
          JSON.stringify(this.filtroTabelaPessoa)
        )
        .then((res) => {
          this.dadosPessoa = res.data;
          this.totalRegistro = res.data.totalElements;
          this.reorganizarDadosPessoa();
        });
    },

    exportExcel() {
      let jsonPost = {
        idenPessoaExercicio: this.idenPessoaExercicio,
        tipoRelatorio: "EXCEL",
        usuarioLogado:
          this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
        orgaoLotacao:
          this.$store.getters.getUser.contaAcesso.pessoa
            .listaServidorOrgaoSetor[0].descOrgao,
      };

      this.$http
        .post(
          `${baseApiUrl}/auditorias/relatorio/auditoria`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          download(
            `data:application/excel;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/excel"
          );
        });
    },
    
    exportPDF(elemento) {
      let jsonPost = {
        idenPessoaExercicio: elemento.idenPessoaExercicio,
        idenPessoaFiscal: this.idenPessoaUsuario,
        usuarioLogado:
          this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
        orgaoLotacao:
          this.$store.getters.getUser.contaAcesso.pessoa
            .listaServidorOrgaoSetor[0].descOrgao,
      };

      this.$http
        .post(
          `${baseApiUrl}/permissoesfiscais/relatorio`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          this.dadosRelatorioBase64 = `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`;
          this.isExibirPDF = true;
        });
    },
  },     
  mounted() {
      this.carregarDados();
  },

};
</script>

<style scoped>
.label-info {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 0.4rem;
}

.container-cabecalho {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.container-cabecalho > div {
  margin-bottom: 0.9rem;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.button-acoes > button {
  margin: 0.3rem auto;
}

.container-filtro {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.classe-buttom {
  max-width: 10rem;
  max-height: 40px;
  margin-top: 14px;
}

@media screen and (max-width: 425px) {
  .classe-input {
    margin-bottom: 0.5rem;
    /* margin: auto 0.5rem; */
  }

  .container-filtro {
    display: flex;
    flex-direction: column;
  }

  .classe-dropdown {
    margin-bottom: 0.5rem;
  }

  .classe-buttom {
    max-width: 100%;
  }
}
</style>

<style>
.column-acoes {
  width: 20rem;
}

.button-icon {
  font-size: 1.5rem;
}

@media screen and (min-width: 481px) and (max-width: 1080px) {
  .column-acoes {
    width: 5rem;
  }

  .button-acoes > button > span {
    display: none;
  }
  .button-acoes > button {
    padding: 0.5rem 0.69rem;
  }
  .button-icon {
    font-size: 1.5rem;
  }
}
</style>